// TODO : this is just temp structure
export var locationsMockData = [{
  main: "Antario",
  sub: "Colorado, United States"
}, {
  main: "Antonito Road",
  sub: "Blanca, Colorado 81123, United States"
}, {
  main: "Antonito Convention Center",
  sub: "San Luis, Colorado 81152, United States"
}, {
  main: "Antonito Museum",
  sub: "Romeo, Colorado 81148, United States"
}, {
  main: "Romeo, Colorado 81148, United States",
  sub: "Blanca, Colorado 81123, United States"
}];
export var nearbyRestaurants = [{
  name: "Atlanta - Toco Hills",
  address: "2892 North Druid Hills Road Atlanta, GA 30329",
  phone: "(404) 982-9703",
  onRight: "button"
}, {
  name: "Albuquerque - Cottonwood",
  address: "9975 Coors Bypass NW Albuquerque, NM 87114",
  phone: "(505) 897-0081",
  onRight: "button"
}, {
  name: "(505) 897-0081",
  address: "5707 Barnes Road Colorado Springs, CO 80917",
  phone: "(719) 597-6352",
  onRight: "button"
}, {
  name: "Littleton",
  address: "8285 West Bowles Avenue Littleton, CO 80123",
  phone: "((303) 948-3111",
  onRight: "button"
}, {
  name: "Antario",
  address: "Colorado, United States",
  phone: "(404) 982-9703",
  onRight: "button"
}];